export default "__VITE_ASSET__CbmU4e6m__"